import styled from 'styled-components';
import 'styled-system';
import 'react-responsive';
import { mobile } from '../../styles/breakpoints.js';
import Box from './box.js';
var ContainerSmall = /*#__PURE__*/styled(Box).attrs(function (_ref) {
  var position = _ref.position,
      margin = _ref.margin;
  return {
    position: position || 'relative',
    maxWidth: 'calc(46rem + 4rem)',
    // 46rem = 736px
    padding: '0 2rem',
    margin: margin || 'auto'
  };
}).withConfig({
  displayName: "container-small__ContainerSmall",
  componentId: "sc-tugr8q-0"
})(["@media ", "{padding:0 1rem;}"], mobile);
export default ContainerSmall;
export { ContainerSmall };